/**
 * Popup de complementos al añadir al carrito (sustituye al popup de Planet).
 * Lo abre product-form.js con show() después de añadir el producto principal.
 */
if (!customElements.get("upsell-popup")) {
  class UpsellPopup extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector("dialog");
      if (!this.dialog) return;

      this.addEventListener("click", this.handleClick.bind(this));
      this.addEventListener("change", this.handleChange.bind(this));
      this.dialog.addEventListener("close", () => {
        document.documentElement.classList.remove("upsell-popup-abierto");
      });
    }

    show() {
      if (!this.dialog || this.dialog.open) return;
      this.dialog.showModal();
      document.documentElement.classList.add("upsell-popup-abierto");
      UpsellPopup.track("upsell_popup_view", {
        product_id: this.dataset.productId,
      });
    }

    close() {
      if (this.dialog && this.dialog.open) this.dialog.close();
    }

    /**
     * @param {object} evt - Event object.
     */
    handleClick(evt) {
      // Clic en el fondo oscuro (fuera de la caja). Los márgenes interiores
      // también tienen como target el dialog, por eso se mira la posición.
      if (evt.target === this.dialog) {
        const rect = this.dialog.getBoundingClientRect();
        const fuera =
          evt.clientX < rect.left ||
          evt.clientX > rect.right ||
          evt.clientY < rect.top ||
          evt.clientY > rect.bottom;
        if (fuera) this.close();
        return;
      }

      if (evt.target.closest("[data-upsell-close]")) {
        this.close();
        return;
      }

      if (evt.target.closest("[data-upsell-view-cart]")) {
        this.close();
        const cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer && typeof cartDrawer.open === "function") {
          cartDrawer.open();
        } else {
          window.location.href = theme.routes.cart;
        }
        return;
      }

      const addBtn = evt.target.closest("[data-upsell-add]");
      if (addBtn) this.addItem(addBtn);
    }

    /**
     * Actualiza el precio al cambiar de variante.
     * @param {object} evt - Event object.
     */
    handleChange(evt) {
      const select = evt.target.closest("[data-upsell-variante]");
      if (!select) return;

      const item = select.closest(".upsell-popup__item");
      const option = select.options[select.selectedIndex];
      const price = item.querySelector("[data-upsell-precio]");
      if (price && option.dataset.precio) price.innerHTML = option.dataset.precio;
      item.querySelector("[data-upsell-add]").dataset.variantId = select.value;
    }

    /**
     * Añade un complemento sin salir del popup y refresca cajón e icono.
     * @param {Element} btn - Botón "Añadir".
     */
    async addItem(btn) {
      if (btn.getAttribute("aria-disabled") === "true") return;

      const item = btn.closest(".upsell-popup__item");
      const select = item.querySelector("[data-upsell-variante]");
      const errorEl = item.querySelector(".upsell-popup__error");
      const variantId = select ? select.value : btn.dataset.variantId;
      const cartDrawer = document.querySelector("cart-drawer");
      const sections = ["cart-icon-bubble"];

      if (cartDrawer) {
        sections.push(
          cartDrawer.closest(".shopify-section").id.replace("shopify-section-", "")
        );
      }

      btn.setAttribute("aria-disabled", "true");
      btn.classList.add("is-loading");
      if (errorEl) errorEl.hidden = true;

      try {
        const response = await fetch(`${theme.routes.cartAdd}.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            items: [{ id: Number(variantId), quantity: 1 }],
            sections,
            sections_url: window.location.pathname,
          }),
        });
        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.description || data.message || response.status);
        }

        if (cartDrawer && typeof cartDrawer.renderContents === "function") {
          cartDrawer.renderContents(data, false);
        } else if (data.sections) {
          const bubble = document.getElementById("cart-icon-bubble");
          if (bubble) bubble.innerHTML = data.sections["cart-icon-bubble"];
        }

        btn.classList.remove("is-loading");
        btn.classList.add("is-added");
        btn.textContent = btn.dataset.addedText;
        if (select) select.disabled = true;

        UpsellPopup.track("upsell_popup_add", {
          product_id: this.dataset.productId,
          upsell_variant_id: variantId,
          upsell_title: item.dataset.productTitle,
        });
      } catch (error) {
        btn.classList.remove("is-loading");
        btn.removeAttribute("aria-disabled");
        if (errorEl) {
          errorEl.textContent = error.message;
          errorEl.hidden = false;
        }
      }
    }

    /**
     * Evento para GTM (si está cargado) para medir el popup como se hacía con Planet.
     * @param {string} event - Nombre del evento.
     * @param {object} detail - Datos del evento.
     */
    static track(event, detail) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event, ...detail });
    }
  }

  customElements.define("upsell-popup", UpsellPopup);
}
